import { DevicePreviewPreviewStateChangeEvent, TelemetryEvents } from '../../common/telemetryEvents/TelemetryEvents';
import { Telemetry } from '../../commonInfra/services/Telemetry';
import { DeviceType } from '../../ts/models/DeviceType';
import { IPreviewDeviceSize, IPreviewDeviceSizes } from '../../ts/models/IPreviewDeviceSize';
import { ISize } from '../../ts/models/ISize';
import { IWorkbookActions } from '../../workbook/ServerApi/types/IWorkbookActions';

export const DeviceSizes: IPreviewDeviceSizes = {
  phone: {
    width: '375px',
    height: '667px'
  },
  tablet: {
    width: '1024px',
    height: '768px'
  },
  desktop: {
    width: '1024px',
    height: '800px'
  }
};

export const MIN_PHONE_ZOOM_RATIO = .25;

let previewDevice: DeviceType = 'phone';

export namespace DevicePreviewService {
  export function getPreviewDevice(): DeviceType {
    return previewDevice;
  }

  export function changePreviewDevice(device: DeviceType): DeviceType {
    if (previewDevice !== device) {
      Telemetry.sendEvent<DevicePreviewPreviewStateChangeEvent>({
        type: TelemetryEvents.DevicePreviewPreviewStateChange,
        preview_device_type: device
      });

      previewDevice = device;
      return previewDevice;
    }
    return null;
  }

  export function getSize(): IPreviewDeviceSize {
    return DeviceSizes[previewDevice];
  }

  function hasWebAuthoringPermissionOnWorkbook(workbookActions: IWorkbookActions): boolean {
    return workbookActions['launchWebAuthoring'];
  }

  // This is used to show the control to Preview Device Layouts so as not to clutter up the UI unless needed
  export function isEnabledWithWorkbookPermission(workbookActions: IWorkbookActions): boolean {
    return hasWebAuthoringPermissionOnWorkbook(workbookActions);
  }

  // To mimic how a dashboard is actually displayed on a phone,
  // we currently zoom out the Viz up to 25% of the original viz size.
  // getShrunkenSizeForPhone is used to calculate the ultimate Viz size when there has been shrinking.
  export function getShrunkenSizeForPhone(sheetSize: tb.ISheetSize): ISize | null {
    const minSize = sheetSize.minSize;

    if (getPreviewDevice() === 'phone' && minSize) {
      const origWidth: number = parseInt(getSize().width, 10);
      const origHeight: number = parseInt(getSize().height, 10);

      if (minSize.width > origWidth) {
        const zoomRatio = Math.max(origWidth/minSize.width, MIN_PHONE_ZOOM_RATIO);
        // Iframe size should always be at least the device size for preview purposes.
        const newWidth = Math.max(minSize.width * zoomRatio, origWidth);
        const newHeight = Math.max(minSize.height * zoomRatio, origHeight);
        return {
          width: newWidth,
          height: newHeight
        };
      }
    }

    return null;
  }
}
